import { Node } from "slate";
export var getCharCount = function (nodes) {
    return nodes.map(function (n) { return Node.string(n); }).join("\n").length;
};
